import React from 'react';

const GrupoUnidadeNegocio = React.createContext();

export default GrupoUnidadeNegocio;
